/*---[ ESLint ]---*/
/*
    global precommsgresplog
*/

window.precommsgresplog = function () {

    var selectedPreComMsgLogID = 0;
    var LABEL_ETooManyDays = "";
    var LABEL_ENoDataFound = "";
    var dateTimeErrorMessageLabel = "";

    function setVisibilityPeriodSelector() {

        var ddl = $("#TimeIntervalID").data("kendoDropDownList");

        if (ddl != null && ddl != undefined) {
            var timeinterval_value = parseInt(ddl.value());
            var show = (timeinterval_value == timeIntervalEnum.AskedPeriod);
            main.setHideDiv("periodSelector", show);
        }
    }

    return {

        initialize: function (ETooManyDays, ENoDataFound, dateTimeErrorMessage) {
            LABEL_ETooManyDays = ETooManyDays;
            LABEL_ENoDataFound = ENoDataFound;
            dateTimeErrorMessageLabel = dateTimeErrorMessage;

            setVisibilityPeriodSelector();
            main.setHideDivBootstrap("PreComMsgResponsesGrid", false);
            main.setHideDiv("errorMessage", false);

            precommsgresplog.searchButtonClicked();
        },

        searchButtonClicked: function () {
            $("#SearchButtonLoader").show();

            main.setHideDiv("DivLblTooMany", false);
            main.setHideDiv("DivGridMsg", false);
            main.setHideDiv("errorMessage", false);

            var selectedInterval = parseInt($("#TimeIntervalID").data("kendoDropDownList").value());
            var from = timeinterval.GetBeginPeriodSelection(selectedInterval);
            var to = timeinterval.GetEndPeriodSelection(selectedInterval);

            if (from != null && to != null) {
                var grid = $("#PreComMsgResponseLogGrid").data("kendoGrid");
                if (grid != null && grid != undefined) {
                    grid.pager.dataSource.page(1);
                    grid.dataSource.read();
                }
            }
            else {
                $("#SearchButtonLoader").hide();
                // make a message
                main.setHideDiv("errorMessage", true);

                var lblError = $("#errorMessageLabel");
                if (lblError != null && lblError != undefined) {
                    lblError.text(dateTimeErrorMessageLabel);
                }
            }
        },

        getAdditionalData: function () {

            // defaults
            var beginDateTime = moment();
            var fromLocalMRL = new Date(beginDateTime.subtract(1, 'days').unix() * 1000);
            var toLocalMRL = new Date(beginDateTime.unix() * 1000);

            // timeinterval
            var ddl = $("#TimeIntervalID").data("kendoDropDownList");
            if (ddl != null && ddl != undefined) {
                var ddlval = parseInt(ddl.value());

                fromLocalMRL = timeinterval.GetBeginPeriodSelection(ddlval);
                toLocalMRL = timeinterval.GetEndPeriodSelection(ddlval);

                var tsDays = (toLocalMRL - fromLocalMRL) / (1000 * 3600 * 24);
                if (tsDays < 0 || tsDays >= 33) {

                    // make a message
                    main.setHideDiv("DivLblTooMany", true);

                    var lblEmsg = $("#LblTooMany");
                    if (lblEmsg != null && lblEmsg != undefined) {
                        lblEmsg.text(LABEL_ETooManyDays);
                    }

                    fromLocalMRL = toLocalMRL = new Date(Date.now());
                }

                // always add future appointments when not AskedPeriod
                if (ddlval != timeIntervalEnum.AskedPeriod) {
                    toLocalMRL = new Date();
                    toLocalMRL.setFullYear(toLocalMRL.getFullYear() + 1);
                }
            }

            return {
                fromLocal: fromLocalMRL,
                toLocal: toLocalMRL
            };
        },

        showIsVisible: function (dataItem) {
            return dataItem.Sent != null;
        },

        deleteIsVisible: function (dataItem) {
            return dataItem.Sent == null;
        },

        getAdditionalDataResp: function () {

            return {
                preComMsgLogID: selectedPreComMsgLogID
            };
        },

        onChangeTimeInterval: function () {
            setVisibilityPeriodSelector();

            main.setHideDivBootstrap("PreComMsgResponsesGrid", false);
        },

        onDataBound: function (e) {
            $("#SearchButtonLoader").hide();

            if (e.sender.dataSource.view().length < 1) {
                main.setHideDiv("DivGridMsg", true);
                var lblEmsg = $("#LblGridMsg");
                if (lblEmsg != null && lblEmsg != undefined) {
                    lblEmsg.text(LABEL_ENoDataFound);
                }
            }
        },

        ShowMessageResponse: function (e) {

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            selectedPreComMsgLogID = dataItem.PreComMsgLogID;

            if (selectedPreComMsgLogID > 0) {
                main.setHideDivBootstrap("PreComMsgResponsesGrid", true);
                $("#PreComMsgResponsesGrid").data("kendoGrid").dataSource.read();
            }
        },

        DeleteMessageResponse: function (e) {

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            selectedPreComMsgLogID = dataItem.PreComMsgLogID;

            var event = e;
            var data = this;

            function callbackYes(event, data) {

                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

                // Post Data
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("PreComMsgResponseLog/Delete?preComMsgLogId=" + dataItem.PreComMsgLogID),
                    success: function (responseData) {

                        if (responseData != undefined && responseData != null) {
                            if (responseData.Succesfully == false) {
                                main.openActionsDialog(' ', responseData.Message,
                                    [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                            }
                        }

                        // Refresh datasource grid
                        $("#PreComMsgResponseLogGrid").data("kendoGrid").dataSource.read();
                    }
                });
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });
        },


        startChanged: function () {
        },

        endChanged: function () {
        }

    }

}();
